import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Layout, Icon, Row } from 'antd';
import { connect } from 'react-redux';

import { LogoName } from 'components/common/elements/Logo';
import { logout, toggleFeedbackModal } from 'actions/appActions';
import Breakpoint from 'components/layout/Breakpoint.js';
import MainMenu from 'components/layout/MainMenu.js';
import withRoute from 'components/hocs/withRoute.js';

const { Header } = Layout;

@withRoute
@connect(null, { logout, toggleFeedbackModal })
class AppHeader extends Component {
    state = {
        opened: false
    };

    handleMenuToggle = (opened = !this.state.opened) => {
        this.setState({ opened });

        if (opened) {
            document.body.classList.add('overlay');
        } else {
            document.body.classList.remove('overlay');
        }
    }

    componentWillReceiveProps(props) {
        if (this.props.location.pathname !== props.location.pathname) {
            this.handleMenuToggle(false);
        }
    }

    render() {
        const {opened} = this.state;

        return (
            <div className={opened ? 'header-fullscreen' : ''}>

                <Header>
                    <div className="header-menu">
                        <div className="right-logo">
                            <LogoName />        
                        </div>
                        <Row type="flex" align="middle">
                            <Breakpoint min="sm">
                                <a className="exit header-menu__link" onClick={this.props.toggleFeedbackModal}>
                                    <Icon type="mail" />  Обратная связь
                                </a>
                                <a className="exit header-menu__link" onClick={this.props.logout}>
                                    <Icon type="logout" /> Выйти
                                </a>
                            </Breakpoint>
                            <Icon type={opened ? 'cross' : 'menu-unfold'} className="burger color-title" onClick={() => this.handleMenuToggle()}/>
                        </Row>

                    </div>
                </Header>
                {opened && <div className="header-menu-main">
                    <MainMenu />
                    <Breakpoint max="sm">
                        <a className="exit" onClick={this.props.toggleFeedbackModal}>
                            <Icon type="mail" /> Обратная связь
                        </a>
                        <a className="exit" onClick={this.props.logout}>
                            <Icon type="logout" /> Выйти
                        </a>
                    </Breakpoint>
                </div>}
            </div>
        )
    }
}

export default withRouter(AppHeader);



// WEBPACK FOOTER //
// ./src/components/layout/AppHeader.js